import script from "./NumberComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberComponent.vue?vue&type=script&setup=true&lang=js"

import "./NumberComponent.vue?vue&type=style&index=0&id=380558ff&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380558ff"]])

export default __exports__